// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WRgr7","toggle":"styles_toggle__2R9_L","preview":"styles_preview__3Mtxx"};